import React from "react";
import Icon3PL from "../../../../layout/icons/Icon3PL";
import { DailyPickupMarker } from "../../../mapComponents/Markers";
import TrailerDropHookIcon from "../RouteExecution/utils/DriverStatus/Icons/TrailerDropHookIcon";
import { ExcessiveLength, LiftGateOverride, RESUNA, TrailerBackFill, TrailerSwap, CustomerComments, TrailerLength, WhiteGloveDelivery, NINV, PhysicalDR } from "../icons";
import {SVG_ICON_NAME} from "../../../../appConstants";
import DockDropIcon from "../../../../layout/icons/DockDropIcon";
import {AttachMoney as DollarIcon, People as TwoMan , LocalShippingOutlined as CargoVan, MoneyOff} from '@material-ui/icons';
import ExhibitPickup from "../../../../layout/icons/ExhibitPickup";
import LiveUnload from "../../../../layout/icons/LiveUnload";
import MoneyOffWithOutline from "../../../../layout/icons/MoneyOffWithOutline";
import DOWIcon from "../../../../layout/icons/DOWIcon";

const getSvgIcons = ({iconName, backgroundColor, borderColor, size, label}) => {
  switch (iconName) {
    case SVG_ICON_NAME._3PL:
      return <Icon3PL color={backgroundColor} size={size} />;
    case SVG_ICON_NAME.SWAP:
      return <TrailerDropHookIcon color={backgroundColor} size={size} />;
    case SVG_ICON_NAME.dailyPickup:
      return (
        <DailyPickupMarker
          backgroundColor={backgroundColor}
          borderColor={borderColor}
          size={size}
        />
      );
    case SVG_ICON_NAME.ExcessiveLength: 
      return <ExcessiveLength color={backgroundColor} size={size}/>;
    case SVG_ICON_NAME.RESUNA: 
      return <RESUNA color={backgroundColor} size={size}/>;
    case SVG_ICON_NAME.TrailerBackFill:
      return <TrailerBackFill color={backgroundColor} size={size} />;
    case SVG_ICON_NAME.LiftGateOverride:
      return <LiftGateOverride color={backgroundColor} size={size} />;
    case SVG_ICON_NAME.TrailerSwap:
      return <TrailerSwap color={backgroundColor} size={size} />;
    case SVG_ICON_NAME.DockDrop: 
      return <DockDropIcon color={backgroundColor} size={size} />;
    case SVG_ICON_NAME.COD:
      return <DollarIcon color={backgroundColor} size={size} style={{ fontSize: 16}}/>;
    case SVG_ICON_NAME.ExhibitPickup: 
      return <ExhibitPickup color={backgroundColor} size={size} />;
    case SVG_ICON_NAME.TwoMan:
      return <TwoMan color={backgroundColor} size={size} style={{ fontSize: 16}}/>;
    case SVG_ICON_NAME.CargoVan:
      return <CargoVan color={backgroundColor} size={size} style={{ fontSize: 16}}/>;
    case SVG_ICON_NAME.LiveUnload:
      return <LiveUnload color={backgroundColor} size={size}/>;
    case SVG_ICON_NAME.Hold:
      return <MoneyOff color={backgroundColor} size={size} style={{ fontSize: 16}}/>;
    case SVG_ICON_NAME.HoldRM:
      return <MoneyOffWithOutline color={backgroundColor} size={size} style={{ fontSize: 16}}/>;
    case SVG_ICON_NAME.CustomerComments:
    case SVG_ICON_NAME.ShipperComments:
      return <CustomerComments color={backgroundColor} size={size} />;
    case SVG_ICON_NAME.DOW:
      return <DOWIcon color={backgroundColor} label={label} />;
    case SVG_ICON_NAME.TrailerLength:
      return <TrailerLength color={backgroundColor} size={size} />;
    case SVG_ICON_NAME.WhiteGloveDelivery:
      return <WhiteGloveDelivery color={backgroundColor} size={size} />;
    case SVG_ICON_NAME.NINV:
      return <NINV color={backgroundColor} size={size} />;
    case SVG_ICON_NAME.PhysicalDR:
      return <PhysicalDR color={backgroundColor} size={size} />;
    default:
      return null;
  }
};

const getThemeColorByIconName = (iconType, theme) => {
  if (iconType?.value === SVG_ICON_NAME.dailyPickup) {
    return {
      backgroundColor: theme.unassignPickupFillColor,
      borderColor: theme.markerStokeColor
    };
  }
  return { backgroundColor: iconType?.iconStyles?.color || theme.iconColor };
};

export { getSvgIcons, getThemeColorByIconName };